import { toast as notify } from "react-toastify";

import AppToast from "../components/UX/AppToast";

const BASE_OPTIONS = {
  hideProgressBar: true,
  closeButton: false,
  icon: false,
  className: "app-toast",
  bodyClassName: "app-toast-body",
};

function show(type, message, options = {}) {
  const { subtitle, ...restOptions } = options;

  return notify(
    <AppToast title={message} subtitle={subtitle} type={type} />,
    {
      type,
      ...BASE_OPTIONS,
      ...restOptions,
    }
  );
}

export const toast = {
  success: (message, options) => show("success", message, options),
  error: (message, options) => show("error", message, options),
  info: (message, options) => show("info", message, options),
  POSITION: notify.POSITION,
};
